export const NAJVA_CSS_URL =
  "https://van.najva.com/static/cdn/css/local-messaging.css";

export const NAJVA_SCRIPT_URL =
  "https://van.najva.com/static/js/scripts/farapon-website-10044-31e4eca2-0f0a-442b-862d-2f9b8742ce8e.js";
